import * as GlobalConstants from '../constants/globalConstants';

const initialState = {
    loading: false,
};

export default function global(state = initialState, action) {

    switch (action.type) {
        case GlobalConstants.LOADING_START:
            return {
                ...state,
                loading: true,
            };

        case GlobalConstants.LOADING_FINISH:
            return {
                ...state,
                loading: false,
            };

        case GlobalConstants.GET_SUBJECTS_CATEGORIES:
            return {
                ...state,
                subjects: action.subjects ? action.subjects : state.subjects,
            };

        default:
            return state;
    }
}
